"use client";

import { useState } from "react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ProjectGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);
  const [clickedCard, setClickedCard] = useState<number | null>(null);
  const projects = [{
    id: 1,
    title: "Advanced Materials Innovation",
    image: "https://famous-marmoset.10web.cloud/wp-content/uploads/2026/05/Yoga_mat_case_study-scaled.png?v=1w7zye48vy6",
    summary: "Engineering the Next Generation of Premium Yoga Products",
    details: "Partnered with Manduka® to develop advanced materials technologies that enhanced the performance of the PRO®, GRP ADAPT®, and eKO® product lines, delivering improved grip, sustainability, durability, and user experience through innovative materials engineering.",
    link: {
      href: "https://famous-marmoset.10web.cloud/case-studies/advanced-material-innovation/",
      newTab: false
    }
  }, {
    id: 2,
    title: "Sustainable Packaging Solutions",
    image: "https://famous-marmoset.10web.cloud/wp-content/uploads/2026/05/Packaging_case_study-scaled.png?v=m2hctjnt07",
    summary: "Developing Sustainable Packaging for Global Consumer Brands",
    details: "Partnered with leading consumer products companies to develop recyclable packaging, increase post-consumer recycled content, and reduce virgin plastic use. Highlights include a patented mono-material barrier film designed to replace traditional metallized packaging while enabling recyclable flexible packaging.",
    link: {
      href: "https://famous-marmoset.10web.cloud/case-studies/sustainable-packaging-solutions/",
      newTab: false
    }
  }, {
    id: 3,
    title: "Due Diligence for Strategic Acquisitions",
    image: "https://famous-marmoset.10web.cloud/wp-content/uploads/2026/07/CSP_Acquisition_Diligence_dbg.png?v=5r0ncg93khf",
    summary: "Supporting Aptar's Acquisition of CSP Technologies",
    details: "Supported Aptar's acquisition of CSP Technologies by leading technical due diligence across intellectual property, R&D, manufacturing, supply chain, and EHS. Our expertise in functional barrier packaging helped validate strategic value, identify risks, and support informed investment decisions.",
    link: {
      href: "https://famous-marmoset.10web.cloud/case-studies/due-diligence-for-strategic-acquisitions/",
      newTab: false
    }
  }, {
    id: 4,
    title: "End to End Product Development",
    image: "https://famous-marmoset.10web.cloud/wp-content/uploads/2026/05/Stickables_align_01-scaled.jpg?v=bqdvlzst95v",
    summary: "Creating a New Category in Orthodontic Personalization",
    details: "Developed the decoration platform behind the Stickables® product line for Invisalign®, combining advanced materials engineering, adhesive technology, and scalable manufacturing to bring an innovative patient personalization solution from concept to commercial launch.",
    link: {
      href: "https://famous-marmoset.10web.cloud/case-studies/orthodontic-personalization/",
      newTab: false
    }
  }, {
    id: 5,
    title: "Front-End Consumer Innovation",
    image: "https://famous-marmoset.10web.cloud/wp-content/uploads/2026/05/Cosmetics_patch_case_study-scaled.png?v=xlcxht1obt",
    summary: "Developing Next-Generation Cosmetic Product Platforms",
    details: "Partnered with a global beauty leader to develop innovative concepts combining advanced materials, packaging, and functional cosmetic technologies. Projects included transdermal skin patches, instant cosmetic applicators, and unit-dose delivery systems designed to simplify and elevate the consumer experience.",
    link: {
      href: "https://famous-marmoset.10web.cloud/case-studies/front-end-consumer-innovation/",
      newTab: false
    }
  }, {
    id: 6,
    title: "Consumer Products for Brands",
    image: "https://famous-marmoset.10web.cloud/wp-content/uploads/2026/07/Mat_Wash_Products_crop.png?v=97hxym6ld9l",
    summary: "Branded Mat Wash Product Line for Manduka®",
    details: "Developed and produce the branded Mat Wash product line for Manduka®, creating a simple, effective cleaning solution designed to keep yoga mats clean without leaving behind unwanted residue. The formulation uses an organic essential oil base and only three ingredients, supporting both product performance and a clean consumer experience.",
    link: {
      href: "https://famous-marmoset.10web.cloud/case-studies/consumer-products-for-brands/",
      newTab: false
    }
  }, {
    id: 7,
    title: "Embedded R&D Partnership",
    image: "https://famous-marmoset.10web.cloud/wp-content/uploads/2026/05/Automotive_interior_case_study-scaled.png?v=pynqpwteduj",
    summary: "Driving continuous innovation through an embedded R&D partnership",
    details: "Serving as Katzkin's embedded R&D team, we lead product development, quality, and manufacturing improvement, helping launch new platforms, expand OEM channels, and strengthen their position as the leader in premium automotive interiors.",
    link: {
      href: "https://famous-marmoset.10web.cloud/case-studies/embedded-rd-partnership/",
      newTab: false
    }
  }, {
    id: 8,
    title: "Innovation Through IP Strategy",
    image: "https://famous-marmoset.10web.cloud/wp-content/uploads/2026/05/3d_printing_case_study-scaled.png?v=to6e7hgvksl",
    summary: "Using Intellectual Property to Advance Autonomous Manufacturing",
    details: "Partnered with Zellerfeld to identify innovation opportunities within the 3D printed footwear patent landscape. By combining IP strategy with manufacturing innovation, we developed a patent-pending technology that improves productivity, reduces manual rework, and supports fully autonomous production.",
    link: {
      href: "https://famous-marmoset.10web.cloud/case-studies/innovation-through-ip-strategy/",
      newTab: false
    }
  }, {
    id: 9,
    title: "Packaging Production for Brands",
    image: "https://famous-marmoset.10web.cloud/wp-content/uploads/2026/07/Mars-Wrigley-7-696x464-1.jpg?v=omtqg7nyand",
    summary: "Reinventing Pellet Gum Packaging for On-the-Go Consumers",
    details: "Supported Wrigley’s transition from traditional blister packaging to a rigid plastic bottle format for pellet gum, helping create a more convenient, portable, and consumer-friendly package. Delivered a turn-key packaging supply solution for product launch and market build-up.",
    link: {
      href: "https://famous-marmoset.10web.cloud/case-studies/packaging-production-for-brands/",
      newTab: false
    }
  }];
  return <section className="bg-light-background pt-8 pb-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div ref={ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-sans text-4xl font-bold text-foreground-light text-center mb-12">
            Our Project Gallery
          </h2>

          <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
            {projects.map((project, i) => <div key={project.id} data-index={i} className={`break-inside-avoid transition-all duration-200 ease-[cubic-bezier(0.4,0,0.2,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: `${i * 50}ms`
          }} onMouseEnter={() => setHoveredCard(project.id)} onMouseLeave={() => setHoveredCard(null)} onClick={() => {
            setClickedCard(clickedCard === project.id ? null : project.id);
            const ripple = document.createElement("span");
            ripple.classList.add("ripple-effect");
            const card = document.getElementById(`card-${project.id}`);
            if (card) {
              card.appendChild(ripple);
              setTimeout(() => ripple.remove(), 600);
            }
          }}>
                <Card id={`card-${project.id}`} className="bg-card text-card-foreground flex flex-col gap-6 rounded-xl relative overflow-hidden cursor-pointer transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] -translate-y-2 shadow-strong !p-0">
                  <div className="relative overflow-hidden">
                    <img src={project.image} alt={project.title} className={`w-full h-auto object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${hoveredCard === project.id ? "scale-[1.02]" : "scale-100"}`} />
                    <div className={`absolute inset-0 bg-gradient-to-t from-dark-background/90 via-dark-background/60 to-transparent transition-opacity duration-[var(--duration-medium)] ${hoveredCard === project.id ? "opacity-100" : "opacity-70"}`} />
                    <div className={`absolute top-0 left-0 right-0 p-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${hoveredCard === project.id ? "translate-y-0" : "translate-y-1"}`}>
                      <h3 className="font-sans text-xl font-semibold !text-[rgba(248,250,252,1)] drop-shadow-md ![margin:0px_0px_5px_0px] !p-0 !text-center !opacity-[0.97] !bg-[rgba(0,0,0,0.3)]">
                        {project.title}
                      </h3>
                      <div className={clickedCard === project.id ? "bg-dark-background/70 rounded px-3 py-2 mb-2" : "rounded px-3 py-2 mb-2"}>
                        <p className={`text-sm transition-all duration-300 !text-[rgba(248,250,252,1)] ${clickedCard === project.id ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12 pointer-events-none"}`}>
                          {project.summary}
                        </p>
                      </div>
                      <div className={clickedCard === project.id ? "bg-dark-background/75 rounded px-3 py-2" : "rounded px-3 py-2"}>
                        <p className={`text-xs transition-all duration-300 text-gray-200 ${clickedCard === project.id ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12 pointer-events-none"}`}>
                          {project.details}
                        </p>
                        {project.link && <div className={`mt-3 transition-all duration-300 ${clickedCard === project.id ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12 pointer-events-none"}`}>
                            <Link to={project.link.href} newTab={project.link.newTab} className="inline-flex items-center text-xs font-semibold text-accent hover:underline">
                              Read More &rarr;
                            </Link>
                          </div>}
                      </div>
                    </div>
                  </div>
                </Card>
              </div>)}
          </div>
        </div>
      </div>

      <style>{`
        .ripple-effect {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%);
          animation: ripple-animation 600ms ease-out;
          pointer-events: none;
        }

        @keyframes ripple-animation {
          from {
            transform: scale(0);
            opacity: 1;
          }
          to {
            transform: scale(2);
            opacity: 0;
          }
        }
      `}</style>
    </section>;
}